module.exports = "https://cdn.dove.it/_next/static/public/assets/features/feature_3.f4e88be18d673a40b24d81fcd0ebc373.png";